
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./Login.css";

function Login() {
  const [username, setUsername] = useState("");   // ← this is now the NAME field
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL || 'https://backend.kpgmp.in/api';

  /* ── Authenticate using NAME (not email) ── */
  const authenticateUser = async (name, pass, role) => {
    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, password: pass, role }),  // ← send 'name'
      });

      const data = await response.json();

      if (response.ok && data.success) {
        return { success: true, role: data.user.role, user: data.user, token: data.token };
      } else {
        return { success: false, message: data.message || 'Invalid credentials' };
      }
    } catch (error) {
      console.error('Authentication error:', error);
      return { success: false, message: 'Network error. Please try again.' };
    }
  };

  const handleNavigation = (role, userData, token) => {
    login({
      role,
      username: userData.name,
      email: userData.email,
      id: userData.id,
      current_ps: userData.current_ps,
      token
    });
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(userData));

    if (role === 'admin')   navigate('/admin');
    else if (role === 'officer') navigate('/officer');
  };

  const handleAdminLogin = async () => {
    if (!username || !password) { setError("❌ Please enter your name and password"); return; }
    setError(""); setIsLoading(true);
    try {
      const result = await authenticateUser(username, password, 'admin');
      if (result.success && result.role === 'admin') {
        handleNavigation('admin', result.user, result.token);
      } else {
        setError(result.message || "❌ Invalid admin credentials! Please try again.");
      }
    } catch (err) {
      setError("❌ Admin login failed. Please check your credentials.");
    } finally { setIsLoading(false); }
  };

  const handleOfficerLogin = async () => {
    if (!username || !password) { setError("❌ Please enter your name and password"); return; }
    setError(""); setIsLoading(true);
    try {
      const result = await authenticateUser(username, password, 'officer');
      if (result.success && result.role === 'officer') {
        handleNavigation('officer', result.user, result.token);
      } else {
        setError(result.message || "❌ Invalid officer credentials! Please try again.");
      }
    } catch (err) {
      setError("❌ Officer login failed. Please check your credentials.");
    } finally { setIsLoading(false); }
  };

  const roleNames = { admin: "Administrator", officer: "Police Officer" };

  return (
    <div className="login-container">
      <div className={`login-box ${selectedRole ? "compact" : ""}`}>

        {selectedRole && (
          <div className="welcome-screen">
            <div className="welcome-spinner"></div>
            <h2>Welcome {roleNames[selectedRole]}</h2>
            <p>Please enter your credentials to continue...</p>
          </div>
        )}

        {!selectedRole && (
          <>
            <div className="login-header">
              <div className="police-logo"></div>
              <h2>Police Grievance Management Portal - Kanpur Commissionerate</h2>
              <p>Secure Login Portal</p>
            </div>

            {error && <div className="status-message status-error">{error}</div>}

            {/* ── NAME field (was Email) ── */}
            <div className="input-group">
              <label>Username / Name</label>
              <input
                type="text"
                placeholder="Enter your name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading}
                autoComplete="username"
                onKeyDown={(e) => { if (e.key === 'Enter') handleAdminLogin(); }}
              />
            </div>

            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                autoComplete="current-password"
                onKeyDown={(e) => { if (e.key === 'Enter') handleAdminLogin(); }}
              />
            </div>

            <div className="button-group">
              <button
                className={`login-btn btn-admin ${isLoading ? "loading" : ""}`}
                onClick={handleAdminLogin}
                disabled={isLoading}
              >
                {isLoading ? (<><span className="spinner"></span>Logging in...</>) : "Login as Admin"}
              </button>

              <button
                className={`login-btn btn-officer ${isLoading ? "loading" : ""}`}
                onClick={handleOfficerLogin}
                disabled={isLoading}
              >
                {isLoading ? (<><span className="spinner"></span>Logging in...</>) : "Login as Officer"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;